"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAssetApi = void 0;
const axios_1 = __importDefault(require("axios"));
exports.createAssetApi = (axios) => {
    function getAssetFileUploadUrl({ projectId, assetId, fileName, }) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.get(`/project/${projectId}/asset/${assetId}/upload/${fileName}`)).data.uploadUrl;
        });
    }
    return {
        getAssetFileUploadUrl,
        createAsset(_a) {
            var { projectId } = _a, rest = __rest(_a, ["projectId"]);
            return __awaiter(this, void 0, void 0, function* () {
                return (yield axios.post(`/project/${projectId}/assets`, rest)).data;
            });
        },
        updateAsset(_a) {
            var { assetId, projectId } = _a, rest = __rest(_a, ["assetId", "projectId"]);
            return __awaiter(this, void 0, void 0, function* () {
                return (yield axios.put(`/project/${projectId}/asset/${assetId}`, rest))
                    .data;
            });
        },
        deleteAsset({ projectId, assetId, }) {
            return __awaiter(this, void 0, void 0, function* () {
                yield axios.delete(`/project/${projectId}/asset/${assetId}`);
            });
        },
        uploadAssetFile({ projectId, assetId, file, useLocalFileUpload, }) {
            return __awaiter(this, void 0, void 0, function* () {
                if (useLocalFileUpload) {
                    const formData = new FormData();
                    formData.append('file', file);
                    yield axios.post(`/project/${projectId}/asset/${assetId}/upload/${file.name}`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    });
                }
                else {
                    const uploadUrl = yield getAssetFileUploadUrl({
                        projectId,
                        assetId,
                        fileName: file.name,
                    });
                    yield axios_1.default.put(uploadUrl, file, {
                        headers: {
                            'Content-Type': file.type,
                        },
                    });
                }
            });
        },
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXNzZXRBcGkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYXBpL2Fzc2V0QXBpLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsa0RBQWlEO0FBR3BDLFFBQUEsY0FBYyxHQUFHLENBQUMsS0FBb0IsRUFBRSxFQUFFO0lBQ3JELFNBQWUscUJBQXFCLENBQUMsRUFDbkMsU0FBUyxFQUNULE9BQU8sRUFDUCxRQUFRLEdBS1Q7O1lBQ0MsT0FBTyxDQUNMLE1BQU0sS0FBSyxDQUFDLEdBQUcsQ0FDYixZQUFZLFNBQVMsVUFBVSxPQUFPLFdBQVcsUUFBUSxFQUFFLENBQzVELENBQ0YsQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDO1FBQ25CLENBQUM7S0FBQTtJQUVELE9BQU87UUFDTCxxQkFBcUI7UUFDZixXQUFXLENBQUMsRUFZakI7Z0JBWmlCLEVBQ2hCLFNBQVMsT0FXVixFQVZJLElBQUksY0FGUyxhQUdqQixDQURROztnQkFXUCxPQUFPLENBQUMsTUFBTSxLQUFLLENBQUMsSUFBSSxDQUFDLFlBQVksU0FBUyxTQUFTLEVBQUUsSUFBSSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUM7O1NBQ3RFO1FBRUssV0FBVyxDQUFDLEVBb0JqQjtnQkFwQmlCLEVBQ2hCLE9BQU8sRUFDUCxTQUFTLE9Ba0JWLEVBakJJLElBQUksY0FIUyx3QkFJakIsQ0FEUTs7Z0JBa0JQLE9BQU8sQ0FBQyxNQUFNLEtBQUssQ0FBQyxHQUFHLENBQUMsWUFBWSxTQUFTLFVBQVUsT0FBTyxFQUFFLEVBQUUsSUFBSSxDQUFDLENBQUM7cUJBQ3JFLElBQUksQ0FBQzs7U0FDVDtRQUVLLFdBQVcsQ0FBQyxFQUNoQixTQUFTLEVBQ1QsT0FBTyxHQUlSOztnQkFDQyxNQUFNLEtBQUssQ0FBQyxNQUFNLENBQUMsWUFBWSxTQUFTLFVBQVUsT0FBTyxFQUFFLENBQUMsQ0FBQztZQUMvRCxDQUFDO1NBQUE7UUFFSyxlQUFlLENBQUMsRUFDcEIsU0FBUyxFQUNULE9BQU8sRUFDUCxJQUFJLEVBQ0osa0JBQWtCLEdBTW5COztnQkFDQyxJQUFJLGtCQUFrQixFQUFFO29CQUN0QixNQUFNLFFBQVEsR0FBRyxJQUFJLFFBQVEsRUFBRSxDQUFDO29CQUNoQyxRQUFRLENBQUMsTUFBTSxDQUFDLE1BQU0sRUFBRSxJQUFXLENBQUMsQ0FBQztvQkFDckMsTUFBTSxLQUFLLENBQUMsSUFBSSxDQUNkLFlBQVksU0FBUyxVQUFVLE9BQU8sV0FBVyxJQUFJLENBQUMsSUFBSSxFQUFFLEVBQzVELFFBQVEsRUFDUjt3QkFDRSxPQUFPLEVBQUU7NEJBQ1AsY0FBYyxFQUFFLHFCQUFxQjt5QkFDdEM7cUJBQ0YsQ0FDRixDQUFDO2lCQUNIO3FCQUFNO29CQUNMLE1BQU0sU0FBUyxHQUFHLE1BQU0scUJBQXFCLENBQUM7d0JBQzVDLFNBQVM7d0JBQ1QsT0FBTzt3QkFDUCxRQUFRLEVBQUUsSUFBSSxDQUFDLElBQUk7cUJBQ3BCLENBQUMsQ0FBQztvQkFDSCxNQUFNLGVBQVMsQ0FBQyxHQUFHLENBQUMsU0FBUyxFQUFFLElBQUksRUFBRTt3QkFDbkMsT0FBTyxFQUFFOzRCQUNQLGNBQWMsRUFBRSxJQUFJLENBQUMsSUFBSTt5QkFDMUI7cUJBQ0YsQ0FBQyxDQUFDO2lCQUNKO1lBQ0gsQ0FBQztTQUFBO0tBQ0YsQ0FBQztBQUNKLENBQUMsQ0FBQyJ9